import { bffBaseUrlForStage } from './apigee.utils';

const NON_PROD_HOSTNAMES = new Set([
  'localhost',
  'privatschutz-dev.allianz.de',
  'privatschutz-devnext.allianz.de',
  'privatschutz-uat.allianz.de',
  'privatschutz-uatnext.allianz.de',
  'privatschutz-si.allianz.de',
  'privatschutz-fix.allianz.de',
  'privatschutz-lab.allianz.de',
  'privatschutz-edu.allianz.de',
]);

export function isNonProdEnvironment(hostname = window.location.hostname): boolean {
  return NON_PROD_HOSTNAMES.has(hostname);
}

export function isDevUrl(loc = location): boolean {
  return (
    loc.href.includes('?') &&
    (loc.hostname === 'localhost' || loc.hostname === 'privatschutz-dev.allianz.de')
  );
}

export function hasReduxDevtoolsParam(search = window.location.search): boolean {
  return new URLSearchParams(search).has('reduxDevtools') || localStorage.getItem('reduxDevtools') === 'true';
}

export function getBffBaseUrl(origin = window.location.origin): string {
  if (origin === 'https://privatschutz-prod.allianz.de') {
    return 'https://taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/ps20-prod/v1';
  }
  return bffBaseUrlForStage;
}

export function getApigeeActive(origin = window.location.origin): boolean {
  switch (origin) {
    case 'https://privatschutz-prod.allianz.de':
      return true;
    case 'http://localhost':
      return false;
    default:
      return true;
  }
}
